export default "__VITE_ASSET__CzxZ5tf$__"